import React from 'react';
import { Sparkles, Clock } from 'lucide-react';
import HelpIconButton from '../HelpIconButton';

// Screen 10 — Mistral is not yet onboarded into Vendor Management, so this
// is a friendly placeholder card. Once onboarding is complete, this screen
// will be deleted and replaced with a <VendorProfileLink vendor="mistral" />
// instance.

const MistralPlaceholder: React.FC = () => {
  return (
    <div className="space-y-6">
      <div className="flex items-start justify-between">
        <div className="flex items-center gap-3">
          <div className="p-2.5 bg-purple-100 rounded-lg">
            <Sparkles className="w-6 h-6 text-purple-700" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Vendor Profile — Mistral</h1>
            <p className="text-sm text-gray-500 mt-0.5">
              Placeholder — pending full onboarding into Vendor Management.
            </p>
          </div>
        </div>
        <HelpIconButton screenId="vendor-profile-mistral" showLabel />
      </div>

      <div className="p-6 bg-gradient-to-br from-purple-50 to-indigo-50 border border-purple-200 rounded-xl">
        <div className="flex items-start gap-4">
          <div className="p-2.5 bg-white rounded-lg border border-purple-200">
            <Clock className="w-6 h-6 text-purple-700" />
          </div>
          <div className="flex-1">
            <h2 className="text-base font-semibold text-gray-900">Onboarding in progress</h2>
            <p className="mt-1.5 text-sm text-gray-700 leading-relaxed">
              Mistral is currently available inside Jarvis as an optional AI provider
              configuration but has not yet been onboarded as a formal vendor in the
              Jarvis Vendor Management module. Once onboarding is complete, this
              placeholder will be replaced with the live vendor profile card — matching
              the format used by Railway, Anthropic, and OpenAI.
            </p>
          </div>
        </div>
      </div>

      <div className="p-5 bg-white border border-gray-200 rounded-xl">
        <h2 className="text-sm font-semibold text-gray-900">Where Mistral surfaces today</h2>
        <p className="mt-1.5 text-sm text-gray-600 leading-relaxed">
          Mistral is currently visible inside the AI provider configuration (Admin →
          Security → AI providers) as a selectable model backend. No tenant-facing data
          flows through Mistral until a TSG admin explicitly enables it for a workload.
        </p>
      </div>

      <div className="p-4 bg-gray-50 border border-gray-200 rounded-lg text-xs text-gray-500">
        Placeholder screen — will be replaced once Mistral is onboarded in Vendor
        Management and help text from the handoff doc is available.
      </div>
    </div>
  );
};

export default MistralPlaceholder;
